import { MetricRequest } from '@core/models/metric.models'
import { PlayerHolder } from '@core/models/player.models'
import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import {
  parsePlayerComparisonToMetricDetailRequest,
  parsePlayerMatchComparisonToMetricDetailRequest
} from '@features/metric-detail/parsers/player-comparison-metric-detail.parser'
import {
  parsePlayerMatchToMetricDetailRequest,
  parsePlayerToMetricDetailRequest
} from '@features/metric-detail/parsers/player-metric-detail.parser'
import { AggregationContext } from '@features/aggregations/models/aggregations.models'

export const resolvePlayerMetricDetailRequestAdapter = (
  payload: ContextMenuItemEvent,
  { isVsEnabled, isMatch, demarcation }: AggregationContext
): MetricRequest => {
  const { context, value } = getMetricValueAndContext<PlayerHolder>(payload)

  if (isVsEnabled && isMatch) {
    return parsePlayerMatchComparisonToMetricDetailRequest(context.comparison, value, demarcation)
  } else if (isVsEnabled && !isMatch) {
    return parsePlayerComparisonToMetricDetailRequest(context.comparison, value, demarcation)
  } else if (!isVsEnabled && isMatch) {
    return parsePlayerMatchToMetricDetailRequest(context.player, value, demarcation)
  } else {
    return parsePlayerToMetricDetailRequest(context.player, value, demarcation)
  }
}
